const ID_TOKEN_KEY = "id_token";
const ID_INFO = "id_info";
const ID_REFRESH_TOKEN_KEY = "id_refresh_token"

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getRefreshToken = () => {
  return window.localStorage.getItem(ID_REFRESH_TOKEN_KEY);
};

export const saveToken = (token, refresh_token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
  window.localStorage.setItem(ID_REFRESH_TOKEN_KEY, refresh_token);
};

export const saveInfo = info => {
  window.localStorage.setItem(ID_INFO, JSON.stringify(info));
};

export const getInfo = () => {
  return window.localStorage.getItem(ID_INFO);
};


export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(ID_REFRESH_TOKEN_KEY);
  window.localStorage.removeItem(ID_INFO);
};

export default { getToken, saveToken, destroyToken, saveInfo};



// WEBPACK FOOTER //
// ./src/common/jwt.js